<template>
  <router-view />
</template>

<script>
  import { mapActions, mapMutations } from 'vuex';
  import router from '@/router';
  import tender from '@/store/tender';
  import { addModule } from '@/store';

  export default {
    name: 'Tender',
    methods: {
      ...mapMutations('tender', ['clearTenderInfo']),
      ...mapActions('tender', ['loadTenderInfo', 'loadTenderListsInfo', 'loadTenderOffers']),
      ...mapActions('project', ['loadProjectInfo']),
    },
    async created() {
      addModule('tender', tender);
      const tenderId = router.currentRoute.params.tenderId;
      const projectId = router.currentRoute.params.id;
      await this.loadTenderInfo(tenderId);
      await this.loadTenderOffers(tenderId);
      this.loadProjectInfo({ id: projectId, needUpdate: false });
    },
    destroyed() {
      this.clearTenderInfo();
    },
  };
</script>
